import React, {useEffect, useState} from "react";
import {useViewerStore} from "../../../../../../../store/store";
import TreeCartItem from "../TreeCartItem";
import {Button, Col, Row} from "antd";
import TreeCartForm from "../TreeCartForm";

const TreeCartTable: React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const [treeCartTotalCost, setTreeCartTotalCost] = useState(0);
    const {treeCartItems} = useViewerStore((state) => ({
        treeCartItems: state.treeCartItems
    }));

    const treeColumn = [
        {title: 'Tree ID'},
        {title: 'Location'},
        {title: 'DBH'},
        {title: 'Height'},
        {title: 'Stump'},
        {title: 'Haul Wood'},
        {title: 'No. of Obst'},
        {title: 'Total'},
    ];

    //whenever treeCartItems changes show loader
    useEffect(() => {
        recalculateTreeCartTotal();
    }, [treeCartItems]);

    const recalculateTreeCartTotal = () => {
        let total = 0;

        treeCartItems?.map((cartTree) => {
            total += cartTree.userData.treeCartInfo?.total as number | 0;
            setTreeCartTotalCost(total);
        });
    }

    const EditCart = () => {
        //Add Tree Form
        sceneViewer.viewerAlert({
            show: true,
            title: "Fill Tree Info",
            message: <TreeCartForm
                selectedTrees={treeCartItems}
                onSubmit={() => {
                    // sceneViewer.refreshShade(false);
                }}
            />,
            messageType: "info",
            isModal: true,
        })
    }

    return (
        <div className={"tab-content-container"}>
            <div className={"tab-content-sticky-container"}>
                <p
                    style={{
                        fontSize: '1.2rem',
                    }}
                >
                    Number of Trees : <b>{treeCartItems?.length}</b>
                </p>
                <Row className="mb-1" style={{alignItems: "baseline"}}>
                    <Col lg={12}>
                        <p style={{fontSize: '1.2rem'}}>
                            <span>Tree Quote :  $ </span>
                            <span id={"treeCartTotalCost"}>
                                <b>{treeCartTotalCost}</b>
                            </span>
                        </p>
                    </Col>
                    <Col lg={12} style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" size="middle" title="Edit Cart" onClick={EditCart}
                                disabled={treeCartItems?.length === 0}>Edit Tree Cart</Button>
                    </Col>
                </Row>
            </div>

            <div className={"tab-content-scrollable-container"}>
            <table className={"tab__table"}>
                <thead
                    style={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        backgroundColor: 'white',
                    }}
                >
                <tr>
                    {treeColumn.map((item, index) => (
                        <th key={index}>{item.title}</th>
                    ))}
                </tr>
                </thead>

                <tbody>
                {treeCartItems?.map((data, index) => (
                    <tr key={index}>
                        <TreeCartItem data={data}/>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
        </div>
    )
}

export default TreeCartTable;